// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryTabs_root__1ccFX","container":"CategoryTabs_container__2tyfh","strip":"CategoryTabs_strip__-6BC0"};